export const TIERS = [
  { name: "Sun Chaser",     badge: "☀️",  min: 0,     max: 499 },
  { name: "Horizon Seeker", badge: "🌅",  min: 500,   max: 1499 },
  { name: "Globe Trotter",  badge: "🌍",  min: 1500,  max: 3999 },
  { name: "Solis Explorer", badge: "✨",  min: 4000,  max: Infinity },
];

export const FOUNDING_TIER = { name: "Founding Explorer", badge: "🏆", min: null, max: null };

export function getTier(points, isFounder) {
  if (isFounder) return FOUNDING_TIER;
  const pts = points || 0;
  return TIERS.find(t => pts >= t.min && pts <= t.max) ?? TIERS[0];
}

export function getNextTier(points) {
  const pts = points || 0;
  const idx = TIERS.findIndex(t => pts >= t.min && pts <= t.max);
  if (idx === -1 || idx === TIERS.length - 1) return null;
  return TIERS[idx + 1];
}
